/* eslint-disable react/require-default-props, no-unused-vars */
import { createTypeElement, createPropTypes } from './util'

const BoxHeadline = ({ as = 'span', ...props }) =>
  createTypeElement('BoxHeadline', { as, ...props })

BoxHeadline.propTypes = createPropTypes()

export default BoxHeadline
